import 'magnific-popup'

$(function() {
  $('.js-slidekitDlBtn').off('click');
  $('.js-slidekitDlBtn').on('click',function(){
    if ($(this).attr('data-passcodemodal')) {
      var dataProduct = $(this).attr('data-product');
      var dataSlideId = $(this).attr('data-slideid');
      var dataFileName = $(this).attr('data-filename');
      $('.js-modalInnerDlBtn').attr('data-product', dataProduct);
      $('.js-modalInnerDlBtn').attr('data-slideid', dataSlideId);
      $('.js-modalInnerDlBtn').attr('data-filename', dataFileName);
      
      $.magnificPopup.open({
        items: [
          {
            src: '#passcodeModal',
            type: 'inline',
          }
        ],
        mainClass: 'p-whiteBackModal',
        closeOnBgClick: false,
        closeBtnInside: false,
        showCloseBtn: true,
        fixedContentPos: true,
        callbacks: {
          open: function(){
            $('body').css('overflow','hidden');
            $('body').css('height','100%');
            $('html').css('height','100%');
          },
          close: function(){
            $('body').css('overflow','auto');
            $('body').css('height','auto');
            $('html').css('height','auto');
          }
        }
      })
    }
  })


});

